/**
 * BGM 표준 컨트롤러.
 *
 * 디자이너가 심어둔 audio 요소([data-fw-bgm-audio] 또는 #bgmPlayer)와
 * 토글 버튼([data-fw-bgm-toggle] 또는 #bgmToggle)을 탐색해 play/pause 바인딩.
 *
 * DOM 규약:
 *   <audio data-fw-bgm-audio src="{{ bgm.url }}" data-volume="{{ bgm.volume }}"
 *          {% if bgm.autoplay %}autoplay{% endif %}
 *          {% if bgm.loop %}loop{% endif %} preload="auto"></audio>
 *   <button data-fw-bgm-toggle aria-label="배경음악 재생"></button>
 *
 * 볼륨: audio 요소의 data-volume (0~1). 미지정이면 0.5.
 *
 * 자동재생:
 *   - audio 에 autoplay 속성이 있으면 모바일 브라우저 정책으로 즉시 재생은 차단됨.
 *   - 그 경우 document 첫 사용자 제스처(pointerdown/touchstart/click/keydown/scroll)
 *     시 1회 audio.play() 를 시도해 모바일에서도 자연스럽게 BGM 이 켜지게 한다.
 *
 * UI 동기화:
 *   - audio 의 play/pause 이벤트로 toggle.dataset.playing 을 갱신.
 *   - 시스템 미디어 컨트롤·자동재생 fallback 등 외부 트리거에도 토글 상태가 일치.
 *
 * 반복재생: HTML <audio loop> 속성이 모든 모바일 브라우저에서 정상 동작 → 별도 처리 없음.
 */
export const BGM_CONTROLLER_SCRIPT = `
<script data-fw-bgm-controller>
(function () {
  function pick(sel) { return document.querySelector(sel); }
  function findAudio() { return pick('[data-fw-bgm-audio]') || pick('#bgmPlayer'); }
  function findToggle() { return pick('[data-fw-bgm-toggle]') || pick('#bgmToggle'); }
  function parseVolume(raw) {
    var n = parseFloat(raw);
    if (isNaN(n)) return 0.5;
    return Math.max(0, Math.min(1, n));
  }
  function safePlay(audio) {
    try {
      var p = audio.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    } catch (_e) {}
  }
  function armAutoplayFallback(audio) {
    var GESTURES = ['pointerdown', 'touchstart', 'click', 'keydown', 'scroll'];
    function detach() {
      for (var i = 0; i < GESTURES.length; i++) {
        document.removeEventListener(GESTURES[i], onGesture, true);
      }
    }
    function onGesture() {
      detach();
      if (audio.paused) safePlay(audio);
    }
    for (var i = 0; i < GESTURES.length; i++) {
      document.addEventListener(GESTURES[i], onGesture, true);
    }
  }
  function init() {
    var audio = findAudio();
    if (!audio || audio.dataset.fwBgmInit) return;
    audio.dataset.fwBgmInit = '1';
    audio.volume = parseVolume(audio.getAttribute('data-volume'));

    var toggle = findToggle();
    if (toggle) {
      toggle.dataset.playing = audio.paused ? 'false' : 'true';
      toggle.addEventListener('click', function () {
        if (audio.paused) safePlay(audio);
        else audio.pause();
      });
      audio.addEventListener('play', function () { toggle.dataset.playing = 'true'; });
      audio.addEventListener('pause', function () { toggle.dataset.playing = 'false'; });
    }

    if (audio.hasAttribute('autoplay') && audio.paused) armAutoplayFallback(audio);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
</script>
`;
//# sourceMappingURL=bgm.js.map